



















import { editFactory } from '@/main/pages';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';

import { editMutations } from './store/types';
import { store } from './store/edit';
import { NAME } from './constants';

export default editFactory(NAME, store).extend({
	components: {
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
	},
	computed: {
		mutationsMappers() {
			return {
				nakladoveStredisko: `${this.storeUri}/${editMutations.SKLAD_PREDMETU_NAKLADOVE_STREDISKO_SELECT_MAPPER}`,
			};
		},
		naklStredFilter() {
			return { ProvozovnaId: this.ProvozovnaId };
		},
	},
	methods: {
		onProvozovnaChange() {
			this.StrednaklOzn = null;
			this.StrednaklOznText = null;
		},
	},
});
